module.exports = __webpack_public_path__ + "img/sflow-config.8d50fa48.png";